// extracted by mini-css-extract-plugin
module.exports = {"component":"EventTooltip_component__2WkyM","iconsBlock":"EventTooltip_iconsBlock__2A8oj","textBlock":"EventTooltip_textBlock__30sO6"};